export default "__VITE_ASSET__BMccelAh__"